import { Box, Stack, Typography } from '@mui/material';
import PlayerNames from './playerNames';

const MultiplePlayerDisplay = ({ teams }) => {
  if (!teams) return null;

  return (
    <Box
      display="grid"
      gridTemplateColumns={'minmax(0, 1fr) auto minmax(0, 1fr)'}
      justifyItems={'center'}
      alignItems={'center'}
      columnGap={1}
      width="100%">
      <PlayerNames team={teams.teamA} />
      <Typography variant="h6" color="primary" fontWeight="bold" sx={{ mx: { xs: 0.5, sm: 2 } }}>
        VS
      </Typography>
      <PlayerNames team={teams.teamB} />
    </Box>
  );
};

export default MultiplePlayerDisplay;
